import { Helmet } from 'react-helmet';

type PageHeaderProps = {
  title: string;
  description: string;
  image?: string;
};

const DEFAULT_IMAGE = '/static/mini-logo.png';

const resolveImageSrc = (image?: string) => {
  if (typeof image === 'string' && image.length > 0 && image !== '[object Object]') {
    return image;
  }
  return DEFAULT_IMAGE;
};

const PageHeader = (props: PageHeaderProps) => {
  const { title, description, image } = props;
  const imageSrc = resolveImageSrc(image);

  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <link rel="apple-touch-icon" href={imageSrc} />

      <title>{title}</title>
      <meta
        name="twitter:title"
        content="Songplace - The best platform to manage your Spotify playlists"
      />
      <meta itemProp="name" content="Songplace" />
      <meta property="og:title" content="Songplace" />
      <meta name="description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta itemProp="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@songplace" />
      <meta name="twitter:image" content={imageSrc} />
      <meta itemProp="image" content={imageSrc} />
      <meta property="og:image" content={imageSrc} />
      <meta property="og:url" content="https://www.songplace.io/" />
    </Helmet>
  );
};

export default PageHeader;
